import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';
import { OPERATIONS } from '../../constants';

const BodyAlign = () => {
	return (
		<CommonOperationScreen
			operationName={OPERATIONS.BODY_ALIGN}
			buttonLabel="Mark BODY ALIGN Complete"
		/>
	);
};

export default BodyAlign;
